import styled from "styled-components";
import {useEffect, useRef, useState} from "react";
import {IntDropdownArea, IntPortalSlot} from "../dropdowns";
import {IntFieldLabeledBox} from "../boxes/int-field-labeled-box";
export const IntDefaultSelect = (
  {
    placeholder,
    label,
    list = [],
    value = '',
    isError = false,
    itemComponent = null,
    dropAreaWidth = null,
    required = false,
    onChange = () => {},
    hideOnChange = true,
    fieldWidth = '100%',
    titleTooltip = (<></>)
  }) => {

  const _list = () => {
    return list && Array.isArray(list) ? list : [];
  }

  const getSelectedByValue = (value) => {
    return _list().find(record => record.value === value);
  }

  const getShowValue = (value) => {
    return getSelectedByValue(value)?.label || '';
  }

  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const [show, setShow] = useState(getShowValue(value));
  const wrapper = useRef(null);
  const target = useRef(null);

  const onSelectHandle = (value) => {
    setSelectedValue(value);
    if(hideOnChange){
        setIsOpen(false);
    }
    setShow(getShowValue(value));
  }

  useEffect(() => {
    onChange(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    setSelectedValue(value);
    setShow(getShowValue(value));
  }, [value]);

  return <Wrapper ref={wrapper} style={{width: fieldWidth}} data-element-name={`int-default-select`}>
    <div ref={target} style={{width: '100%'}} onClick={() => {setIsOpen(true)}}>
      <IntFieldLabeledBox
        placeholder={placeholder}
        label={label}
        isError={isError || (!selectedValue && required)}
        isFocused={isOpen}
        isActive={isOpen || Boolean(selectedValue)}
        titleTooltip={titleTooltip}
      >
        <FieldInput type="text"
           value={show}
           onFocus={() => setIsOpen(true)}
           onChange={({target}) => {}}
        />
      </IntFieldLabeledBox>
      <Icon open={isOpen}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" strokeWidth={'2'} strokeLinecap={"round"} strokeLinejoin={"round"}
        >
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </Icon>
    </div>
    <IntPortalSlot
      dropdownWidth={dropAreaWidth}
      outsideTarget={target.current}
      excludeClickOutsideElements={[wrapper]}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      content={<IntDropdownArea>
        <List>
          {
            _list().map(({label, value, ...payload}) => {
              return itemComponent
                ? itemComponent({label, value, selectedValue, onSelectHandle, ...payload})
                : <Item
                  key={`${value}${label}`}
                  isSelected={selectedValue === value}
                  onClick={() => onSelectHandle(value)}>
                  {label}
                </Item>
            })
          }
        </List>
      </IntDropdownArea>
      }>
    </IntPortalSlot>
  </Wrapper>
}

const Wrapper = styled.div`
  position: relative;
  font-family: inherit;
`;


const Icon = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transition: 0.3s ease;
  transform: ${props => props.open ? `translateY(-50%) rotate(180deg)` : `translateY(-50%)`};
  right: 1rem;
  color: var(--int-default-select-schevron-color, inherit);
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0 .4rem 0 .2rem;
  margin: 0;
`;

const Item = styled.li`
  padding: 0.4rem 1rem;
  text-align: start;
  background-color: ${props => props.isSelected ? '#eee' : '#fff'};
  cursor: pointer;
  margin-bottom: .2rem;
  transition: all .2s ease;
  transform: translateX(0rem);
  border-radius: .4rem;
  
  &:hover {
    transform: translateX(.2rem);
    background-color: #eee;
  }
`;

const FieldInput = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
  display: block;
  width: 100%;
  font-family: inherit;
  font-size: 1rem;
`;